class ContentVideoPlayer {
  elements = undefined;
  constructor(elements) {
    this.elements = elements;
    this.init();
  }

  init() {
    Array.from(this.elements).forEach(function (video) {
      this.initPlayer(video);
    }.bind(this));
  }

  initPlayer(element) {
    const player = new MediaElement(element, {
      youtube: {
        imageQuality: 'maxresdefault',
        showPosterWhenEnded: true,
        nocookie: true,
        controls: 0,
        loop: 0,
        showinfo: 0,
        modestbranding: 1,
        disablekb: 0
      },
      showPosterWhenEnded: true,
      iPadUseNativeControls: true,
      iPhoneUseNativeControls: true,
      AndroidUseNativeControls: true,
      stretching: 'responsive',
      //pluginPath: "/path/to/shims/",
      success: function (mediaElement, originalNode) {
        // do things
        //console.debug("video!!");
      }
    });

    return player;
  }
}
export default ContentVideoPlayer;
